import React, { useEffect, useState } from 'react';
import { useReportContext } from './ReportContext';
import { RevenueReportView } from './RevenueReportView';
export const AnalyticsView = () => {
  const {
    savedReports,
    deleteReport
  } = useReportContext();
  const [viewingReport, setViewingReport] = useState(null);
  const [activeSection, setActiveSection] = useState('overview');
  // Reset to overview if current section is one of the removed sections
  useEffect(() => {
    if (['occupancy', 'seasonal', 'forecast', 'livefeed', 'new-report'].includes(activeSection)) {
      setActiveSection('overview');
    }
  }, []);
  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  const handleViewReport = reportId => {
    setViewingReport(reportId);
    setActiveSection('report');
  };
  const handleDeleteReport = (e, reportId) => {
    e.stopPropagation();
    deleteReport(reportId);
    if (viewingReport === reportId) {
      setViewingReport(null);
      setActiveSection('overview');
    }
  };
  return <div className="flex h-full" data-id="element-88">
      {/* Analytics Sidebar */}
      <div className="w-60 bg-gray-50 border-r border-gray-200 p-4 overflow-auto" data-id="element-89">
        <h2 className="text-lg font-medium text-gray-700 mb-4" data-id="element-90">Analytics</h2>
        <nav className="space-y-1" data-id="element-91">
          {/* Analytics Options */}
          <div className="pt-1 pb-2" data-id="element-92">
            <h3 className="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-93">
              Analytics Options
            </h3>
          </div>
          <button className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md ${activeSection === 'overview' ? 'bg-teal-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => {
          setActiveSection('overview');
          setViewingReport(null);
        }} data-id="element-94">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-95">
              <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" data-id="element-96" />
              <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" data-id="element-97" />
            </svg>
            Overview
          </button>
          <button className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md ${activeSection === 'revenue' ? 'bg-teal-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => {
          setActiveSection('revenue');
          setViewingReport(null);
        }} data-id="element-98">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-99">
              <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" data-id="element-100" />
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" data-id="element-101" />
            </svg>
            Daily Revenue
          </button>
        </nav>
      </div>
      {/* Main Content Area */}
      <div className="flex-1 p-6 bg-white overflow-auto" data-id="element-102">
        {activeSection === 'overview' && <div data-id="element-103">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-104">
              Analytics Overview
            </h2>
            <div className="bg-gray-50 rounded-lg p-6 border border-gray-200 mb-6" data-id="element-105">
              <h3 className="text-lg font-medium mb-2 text-gray-700" data-id="element-106">
                Welcome to Analytics
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-107">
                Select an analytics option from the sidebar to view detailed
                reports.
              </p>
              <p className="text-gray-500 text-sm" data-id="element-108">
                Analytics helps you understand your hospitality business
                performance through data-driven insights.
              </p>
            </div>
          </div>}
        {activeSection === 'revenue' && <RevenueReportView mode="remove" data-id="element-109" />}
        {activeSection === 'report' && viewingReport && <RevenueReportView mode="remove" data-id="element-110" />}
      </div>
    </div>;
};